import { registerMutation } from '@adornis/baseql/metadata/register.js';
import { getCollection } from '@adornis/baseql/server/collections.js';
import { CurrentUserInfo } from '@adornis/users/db/currentUserInfo.js';
import { SUPPORTED_LANGUAGES } from '../../i18n.js';
import { Teacher } from '../teacher.js';

export const setTeacherLanguageMutation = registerMutation({
  operationName: 'setTeacherLanguageMutation',
  type: () => Boolean,
  params: [{ name: 'language', type: () => String }],

  resolve: (language: string) => async () => {
    const sessionData = await CurrentUserInfo.getCurrentUserInfo()({ userID: 1 });

    if (!sessionData?.userID) {
      throw new Error('Nicht autorisiert: Kein User eingeloggt');
    }

    const resolvedLanguage = SUPPORTED_LANGUAGES.some(entry => entry.value === language) ? language : 'de';
    const teacherCollection = await getCollection(Teacher);

    const result = await teacherCollection.updateOne(
      { userID: sessionData.userID },
      {
        $set: {
          language: resolvedLanguage,
        },
      },
    );

    return result.matchedCount > 0;
  },
});
